import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {Router} from '@angular/router';
import {AppointmentsController} from '../appointments/service/appointments.controller';
import {AppointmentsFlowStateService} from '../../common/service/appointments-flow-state.service';
import {
  AppointmentPreselection,
  AppointmentTypeOption,
  InsuranceOption,
  PatientStatusOption
} from '../appointments/model/appointments-models';
import {
  AppointmentTypeCardComponent
} from '../appointments-shared/appointment-type-card/appointment-type-card.component';
import {ErrorBannerComponent} from '../appointments-shared/error-banner/error-banner.component';

@Component({
  selector: 'app-appointments-preselection',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    AppointmentTypeCardComponent,
    ErrorBannerComponent
  ],
  templateUrl: './appointments-preselection.component.html',
  styleUrls: ['./appointments-preselection.component.scss']
})
export class AppointmentsPreselectionComponent implements OnInit {
  isLoading = true;
  errorMessage: string | null = null;

  insuranceOptions: InsuranceOption[] = [];
  appointmentTypes: AppointmentTypeOption[] = [];
  patientStatusOptions: PatientStatusOption[] = [];

  selection: AppointmentPreselection = {
    insurance: null,
    appointmentType: null,
    patientStatus: null
  };

  constructor(
    private controller: AppointmentsController,
    private flowState: AppointmentsFlowStateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const existing = this.flowState.snapshot.preselection;
    this.selection = {...existing};

    this.controller.loadEntryConfig().subscribe({
      next: (config) => {
        this.insuranceOptions = config.insurances;
        this.appointmentTypes = config.appointmentTypes;
        this.patientStatusOptions = config.patientStatus;
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'Die Vorauswahl konnte nicht geladen werden. Bitte versuchen Sie es erneut.';
        this.isLoading = false;
      }
    });
  }

  selectInsurance(option: InsuranceOption) {
    this.selection = {...this.selection, insurance: option};
    this.flowState.updatePreselection(this.selection);
  }

  selectAppointmentType(option: AppointmentTypeOption) {
    this.selection = {...this.selection, appointmentType: option};
    this.flowState.updatePreselection(this.selection);
  }

  selectPatientStatus(option: PatientStatusOption) {
    this.selection = {...this.selection, patientStatus: option};
    this.flowState.updatePreselection(this.selection);
  }

  get canContinue(): boolean {
    return !!this.selection.insurance && !!this.selection.appointmentType && !!this.selection.patientStatus;
  }

  continue() {
    if (!this.canContinue) return;
    this.router.navigate(['/kalender']);
  }
}
